(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/iam-login/assets/javascripts/react/login-iam.js') >= 0) return;  svs.modules.push('/modules/iam-login/assets/javascripts/react/login-iam.js');

'use strict';

const {
  CorpInfo
} = svs.iam_login;
const {
  BrandCubes
} = svs.accountservices_react.brand_cubes;
const {
  Auth
} = svs.iam_login;
const LoginIam = () => {
  const {
    fraudInformationLink
  } = svs.iam_login.data;
  const isMobile = svs.core.detect.formfactor.mobile();
  const isMomang = svs.iam_login.data.isPnp;
  const {
    cdn
  } = svs.core.config.data.svsconfig;
  return React.createElement(React.Fragment, null, React.createElement("img", {
    alt: "",
    className: "login-iam-ao-brand-divider",
    src: "".concat(cdn, "/images/components/ao-logotype-soc/ao-soc.svg"),
    tabIndex: 0
  }), React.createElement("div", {
    className: "".concat(isMomang ? 'fc-white ' : '', "align-center padding-top-2")
  }, React.createElement("h1", {
    className: "f-900 iamlogin-title"
  }, "V\xE4lkommen till", React.createElement("br", null), !isMomang && isMobile && 'Svenska Spel', !isMomang && !isMobile && 'Svenska Spel Sport & Casino', isMomang && 'Momang!', React.createElement("br", null), !isMomang && isMobile && 'Sport & Casino'), isMobile && React.createElement(CorpInfo, null)), React.createElement("div", {
    className: "iamlogin-container align-center padding-sm-top-1 padding-xl-top-2",
    role: "main"
  }, React.createElement(BrandCubes, {
    productId: isMomang ? 10004 : null
  }), React.createElement(Auth, null), React.createElement("p", {
    className: "".concat(isMomang ? 'fc-white ' : '', "padding-top-1")
  }, !isMobile && 'Vid inloggning kontrolleras din identitet, att du är över 18 år', isMobile && 'Vid inloggning kontrolleras din identitet, att du', ' ', React.createElement("br", null), ' ', isMobile && 'är över 18 år och folkbokförd i Sverige.', !isMobile && ' och folkbokförd i Sverige.'), React.createElement("a", {
    className: "u-text-decoration-underline ".concat(isMomang ? 'fc-white ' : 'fc-sport-75'),
    href: fraudInformationLink,
    rel: "noreferrer",
    target: "_blank"
  }, "L\xE4s mer om hur du loggar in s\xE4kert"), !isMobile && React.createElement(CorpInfo, null)));
};
svs.iam_login.LoginIam = LoginIam;

 })(window);